import { BarChart3, Wallet, LineChart } from "lucide-react";
import { Fade } from "./Fade";

const ksps = [
  {
    icon: BarChart3,
    title: "Campaign orchestration",
    description:
      "Manage campaigns across Meta, Google, and TikTok from a single interface. Build, launch, and optimize ad groups, creatives, and budgets — without switching tabs.",
  },
  {
    icon: Wallet,
    title: "Embedded capital",
    description:
      "Matched funding at the campaign level — not a pooled credit facility. Capital is deployed dynamically based on performance, enabling you to scale efficiently without additional upfront investment.",
  },
  {
    icon: LineChart,
    title: "Growth Lever Advisor",
    description:
      "A built-in advisor that surfaces budget shifts, creative fatigue, and performance insights — enabling you to execute or automate decisions in a single click.",
  },
];

export function Features() {
  return (
    <section id="product" className="px-5 sm:px-8 md:px-10 py-20 sm:py-28">
      <div className="max-w-[1280px] mx-auto">
        <Fade>
          <p className="text-xs tracking-[0.2em] uppercase text-[hsl(217_91%_60%)] mb-4 font-medium">
            What is Growth Lever
          </p>
        </Fade>
        <Fade delay={0.05}>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-[-0.02em] max-w-2xl mb-14">
            Scale what works. Multiply results. Stay in control.
          </h2>
        </Fade>

        <div className="grid md:grid-cols-3 gap-6">
          {ksps.map((ksp, i) => (
            <Fade key={ksp.title} delay={0.05 * i} y={16}>
              <div className="border border-white/[0.08] rounded-lg p-6 bg-white/[0.02] hover:bg-white/[0.04] transition-colors h-full">
                <div className="h-9 w-9 rounded-md bg-[hsl(217_91%_60%)]/10 flex items-center justify-center mb-4">
                  <ksp.icon className="h-4.5 w-4.5 text-[hsl(217_91%_60%)]" />
                </div>
                <h3 className="text-base font-semibold mb-2">{ksp.title}</h3>
                <p className="text-sm text-white/40 leading-relaxed">{ksp.description}</p>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </section>
  );
}
